import { useWorkspacesContext } from '../context/WorkspacesContext';

// Agora este hook apenas consome o estado centralizado e unificado
export default function useWorkspaces() {
  return useWorkspacesContext();
}